/* Stylesheet */

.checkbox_item {
  margin: 16px 0px 0px 0px;
  --background: transparent;
  --border-radius: 48px;
  --color: var(--ion-color-text-secondary);

  .icon {
    height: 16px;
    width: 16px;
    color: var(--ion-color-primary);
  }

  .label {
    margin: 0px 0px 0px 21px;
  }
}
